import axios from 'axios'

// 请求拦截
// 接入waf前端发送到接入BOT管理的请求，需要配置withcredentials=true
// 这个参数通常前端框架中默认为false，会禁止js跨域访问cookie，导致BOT管理的框架无法对请求插入校验信息
// 详细解释参考文档 https://liangyihui.feishu.cn/wiki/EhfDwWO0eiHUnsk5RJNcaGomnff?chunked=false 
axios.interceptors.request.use(
  function (config) {
    config.withcredentials = false
    if(config.url.indexOf(window.Global_apiserver) === 0 || config.url.indexOf(window.Global_function_serve) === 0){
      config.withcredentials = true
    }
    // 在 config 上注入发起时间戳，响应拦截器计算耗时用
    // 用 __ 开头避免与 axios 内部字段冲突；外面包一层 try-catch 防止拦截器抛错阻断请求发出
    try {
      config.__lyhNetProbeStartTime = Date.now()
    } catch (_) {
      // 极端情况：config 是 frozen / sealed 对象，赋值抛错。直接忽略，不影响请求。
    }
    return config
  },
  function (error) {
    return Promise.reject(error);
  }
)

/**
 * 安全地提交一次请求耗时到 netUtils 的历史请求队列
 * 设计动机：
 *   - 避免静态 import netUtils -> ajax/config -> netUtils 的循环依赖导致 collectRequestTiming 为 undefined
 *   - 避免 collectRequestTiming 内部抛错影响正常请求响应（埋点必须 0 侵入）
 *   - 首次调用时才动态 require netUtils，破坏循环依赖链
 */
function safeCollectRequestTiming(durationMs) {
  try {
    // 延迟 require，放在函数内部：确保调用时所有模块已初始化完成，破环 import 循环
    // eslint-disable-next-line global-require
    const netUtils = require('@/util/netUtils')
    if (netUtils && typeof netUtils.collectRequestTiming === 'function') {
      netUtils.collectRequestTiming(durationMs)
    }
    // 注：打包器可能把 require 优化掉但本项目是 webpack，require('@/util/netUtils') 是有效的
  } catch (_) {
    // 埋点本身的任何问题都要吞掉，不能影响业务请求
  }
}

// 响应拦截
axios.interceptors.response.use(
  function (response) {
    // vue-resource 统一替换 axios 兼容vue-resource与axios返回体不一致，添加body, bodyText, url, ok字段
    response.body = response.data
    response.bodyText = JSON.stringify(response.data)
    response.url = response.config && response.config.url
    response.ok = false
    if(response.status >= 200 && response.status < 300){
      response.ok = true
    }
    // 成功请求耗时埋点（完全 try-catch，任何异常都不影响返回）
    try {
      const start = response.config && response.config.__lyhNetProbeStartTime
      if (start && typeof start === 'number') {
        const dur = Date.now() - start
        if (dur >= 0) safeCollectRequestTiming(dur)
      }
    } catch (_) { /* 埋点失败静默 */ }
    return response
  },
  function (error) {
    // 失败请求也参与统计（失败本身也是网络/服务差的信号）
    // 完全 try-catch，避免影响 reject 路径
    try {
      const start = error && error.config && error.config.__lyhNetProbeStartTime
      if (start && typeof start === 'number') {
        const dur = Date.now() - start
        if (dur >= 0) safeCollectRequestTiming(dur)
      } else if (error && error.code == 'ECONNABORTED') {
        // axios 超时专用错误码：若没有 start 记录也按典型超时时长兜底（避免样本缺失）
        // 典型 axios 超时默认 10s，但用 3000ms 入列更贴近"慢请求"特征，不会把瞬时超时放大成灾难
        safeCollectRequestTiming(3000)
      }
    } catch (_) { /* 埋点失败静默 */ }
    return Promise.reject(error);
  }
)

export { axios }
